export default "__VITE_ASSET__CMoRFsfW__"